export default {
    contractSummary: {
        title: 'Povzetek pogodbe',
        editContract: 'Uredi pogodbo',
        newContract: '+ Nova pogodba',
        counterparty: 'Nasprotna stranka',
        profileSource: 'Vir profila',
        tenor: 'Ročnost',
        delivery: 'Dobava',
        totalVolume: 'Skupna količina',
        price: 'Cena',
        version: 'Različica',
    },
}
